import Grid from "@mui/material/Grid";
import { useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

// NewProduct page components
import FormField from "layouts/ecommerce/products/new-product/components/FormField";
import { useMemo, useState } from "react";
import EventCalendar from "../../../../../../examples/Calendar";
import calendarEventsData from "../../../../../applications/calendar/data/calendarEventsData";
import MDBadgeDot from "../../../../../../components/MDBadgeDot";
import MDButton from "../../../../../../components/MDButton";
import AmenitiesService from "../../../../../../services/amenities.service";
// import { IMaskInput } from 'react-imask';





function AmenityTimingWeekDay({ validStep, uniqueId, oldValues, valueSetter, ...rest }) {

  const changeValue = (type, dayName, value) => {
    const keyStore = type + "_" + dayName;
    valueSetter(prev => ({
      ...prev,
      [keyStore]: value
    }));
    if (dayName === "monday") {
      setMonday(true);
    } else if (dayName === "sunday") {
      setSunday(true);
    } else if (dayName === "tuesday") {
      setTuesday(true);
    } else if (dayName === "wednesday") {
      setWednesday(true);
    } else if (dayName === "thursday") {
      setThursday(true);
    } else if (dayName === "friday") {
      setFriday(true);
    } else if (dayName === "saturday") {
      setSaturday(true);
    } else if (dayName === "holiday") {
      setHoliday(true);
    }
  }



  const [sunday, setSunday] = useState(false);
  const [start_time_sunday, setStart_time_sunday] = useState(oldValues.start_sunday || "");
  const [end_time_sunday, setEnd_time_sunday] = useState(oldValues.end_sunday || "");

  const [monday, setMonday] = useState(false);
  const [start_time_monday, setStart_time_monday] = useState(oldValues.start_monday || "");
  const [end_time_monday, setEnd_time_monday] = useState(oldValues.end_monday || "");

  const [tuesday, setTuesday] = useState(false);
  const [start_time_tuesday, setStart_time_tuesday] = useState(oldValues.start_tuesday || "");
  const [end_time_tuesday, setEnd_time_tuesday] = useState(oldValues.end_tuesday || "");

  const [wednesday, setWednesday] = useState(false);
  const [start_time_wednesday, setStart_time_wednesday] = useState(oldValues.start_wednesday || "");
  const [end_time_wednesday, setEnd_time_wednesday] = useState(oldValues.end_wednesday || "");

  const [thursday, setThursday] = useState(false);
  const [start_time_thursday, setStart_time_thursday] = useState(oldValues.start_thursday || "");
  const [end_time_thursday, setEnd_time_thursday] = useState(oldValues.end_thursday || "");

  const [friday, setFriday] = useState(false);
  const [start_time_friday, setStart_time_friday] = useState(oldValues.start_friday || "");
  const [end_time_friday, setEnd_time_friday] = useState(oldValues.end_friday || "");

  const [saturday, setSaturday] = useState(false);
  const [start_time_saturday, setStart_time_saturday] = useState(oldValues.start_saturday || "");
  const [end_time_saturday, setEnd_time_saturday] = useState(oldValues.end_saturday || "");


  const [holiday, setHoliday] = useState(false);
  const [start_time_holiday, setStart_time_holiday] = useState(oldValues.start_holiday || "");
  const [end_time_holiday, setEnd_time_holiday] = useState(oldValues.end_holiday || "");

  const [amenities, setAmenities] = useState([]);
  const [sourceAmenity, setSourceAmenity] = useState(null);

  const normalizeTime = (value) => value ? value.substring(0, 5) : "";

  const setWeekDayValue = (dayName, selected, start, end) => {
    switch (dayName) {
      case "monday":
        setMonday(selected);
        setStart_time_monday(start);
        setEnd_time_monday(end);
        break;
      case "tuesday":
        setTuesday(selected);
        setStart_time_tuesday(start);
        setEnd_time_tuesday(end);
        break;
      case "wednesday":
        setWednesday(selected);
        setStart_time_wednesday(start);
        setEnd_time_wednesday(end);
        break;
      case "thursday":
        setThursday(selected);
        setStart_time_thursday(start);
        setEnd_time_thursday(end);
        break;
      case "friday":
        setFriday(selected);
        setStart_time_friday(start);
        setEnd_time_friday(end);
        break;
      case "saturday":
        setSaturday(selected);
        setStart_time_saturday(start);
        setEnd_time_saturday(end);
        break;
      case "sunday":
        setSunday(selected);
        setStart_time_sunday(start);
        setEnd_time_sunday(end);
        break;
      case "holiday":
        setHoliday(selected);
        setStart_time_holiday(start);
        setEnd_time_holiday(end);
        break;
      default:
        break;
    }
  };

  const applyOperationDays = (operationDays) => {
    const days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday", "holiday"];
    const schedule = {};

    days.forEach((dayName) => {
      schedule[dayName] = { selected: false, start: "", end: "" };
    });

    operationDays.forEach((day) => {
      const dayName = day.week_day_name?.toLowerCase();

      if (!schedule[dayName]) return;

      schedule[dayName] = {
        selected: true,
        start: normalizeTime(day.start_time),
        end: normalizeTime(day.end_time),
      };
    });

    days.forEach((dayName) => {
      setWeekDayValue(dayName, schedule[dayName].selected, schedule[dayName].start, schedule[dayName].end);
    });

    valueSetter(prev => ({
      ...prev,
      operation_days: operationDays,
      start_monday: schedule.monday.start,
      end_monday: schedule.monday.end,
      start_tuesday: schedule.tuesday.start,
      end_tuesday: schedule.tuesday.end,
      start_wednesday: schedule.wednesday.start,
      end_wednesday: schedule.wednesday.end,
      start_thursday: schedule.thursday.start,
      end_thursday: schedule.thursday.end,
      start_friday: schedule.friday.start,
      end_friday: schedule.friday.end,
      start_saturday: schedule.saturday.start,
      end_saturday: schedule.saturday.end,
      start_sunday: schedule.sunday.start,
      end_sunday: schedule.sunday.end,
      start_holiday: schedule.holiday.start,
      end_holiday: schedule.holiday.end,
    }));
  };

  useEffect(() => {
    AmenitiesService.getAmenities("")
      .then((response) => {
        const currentAmenityId = oldValues?.id?.toString();
        const amenityList = response.data || [];
        setAmenities(currentAmenityId ? amenityList.filter((amenity) => amenity.id?.toString() !== currentAmenityId) : amenityList);
      })
      .catch(() => {
        setAmenities([]);
      });
  }, [oldValues?.id]);

  const handleSourceAmenityChange = (event, amenity) => {
    setSourceAmenity(amenity);

    if (!amenity?.id) return;

    AmenitiesService.getAmenityInfo(amenity.id)
      .then((response) => {
        const operationDays = response.data?.operation_days || response.data?.amenity_operation_days || [];
        applyOperationDays(operationDays);
      });
  };

  const handleApplyMondayToAllDays = () => {
    const start = start_time_monday || "";
    const end = end_time_monday || "";

    if (!start || !end) return;

    setMonday(true);
    setTuesday(true);
    setWednesday(true);
    setThursday(true);
    setFriday(true);
    setSaturday(true);
    setSunday(true);
    setHoliday(true);

    setStart_time_monday(start);
    setEnd_time_monday(end);
    setStart_time_tuesday(start);
    setEnd_time_tuesday(end);
    setStart_time_wednesday(start);
    setEnd_time_wednesday(end);
    setStart_time_thursday(start);
    setEnd_time_thursday(end);
    setStart_time_friday(start);
    setEnd_time_friday(end);
    setStart_time_saturday(start);
    setEnd_time_saturday(end);
    setStart_time_sunday(start);
    setEnd_time_sunday(end);
    setStart_time_holiday(start);
    setEnd_time_holiday(end);

    valueSetter(prev => ({
      ...prev,
      start_monday: start,
      end_monday: end,
      start_tuesday: start,
      end_tuesday: end,
      start_wednesday: start,
      end_wednesday: end,
      start_thursday: start,
      end_thursday: end,
      start_friday: start,
      end_friday: end,
      start_saturday: start,
      end_saturday: end,
      start_sunday: start,
      end_sunday: end,
      start_holiday: start,
      end_holiday: end,
    }));
  };

  useEffect(() => {
    if (!oldValues || !oldValues.operation_days) return;
    applyOperationDays(oldValues.operation_days);
  }, [oldValues?.operation_days]);

  const handleSetSunday = () => {
    const newValue = !sunday;
    setSunday(newValue);

    if (newValue) {
      valueSetter(prev => ({
        ...prev,
        start_sunday: start_time_sunday,
        end_sunday: end_time_sunday
      }));
    } else {
      valueSetter(prev => ({
        ...prev,
        start_sunday: "",
        end_sunday: ""
      }));
    }
  };
  const handleSetMonday = () => {
    const newValue = !monday;
    setMonday(newValue);

    if (newValue) {
      valueSetter(prev => ({
        ...prev,
        start_monday: start_time_monday,
        end_monday: end_time_monday
      }));
    } else {
      valueSetter(prev => ({
        ...prev,
        start_monday: "",
        end_monday: ""
      }));
    }

  };
  const handleSetTuesday = () => {
    const newValue = !tuesday;
    setTuesday(newValue);

    if (newValue) {
      valueSetter(prev => ({
        ...prev,
        start_tuesday: start_time_tuesday,
        end_tuesday: end_time_tuesday
      }));
    } else {
      valueSetter(prev => ({
        ...prev,
        start_tuesday: "",
        end_tuesday: ""
      }));
    }

  };
  const handleSetWednesday = () => {
    const newValue = !wednesday;
    setWednesday(newValue);

    if (newValue) {
      valueSetter(prev => ({
        ...prev,
        start_wednesday: start_time_wednesday,
        end_wednesday: end_time_wednesday
      }));
    } else {
      valueSetter(prev => ({
        ...prev,
        start_wednesday: "",
        end_wednesday: ""
      }));
    }
  };
  const handleSetThursday = () => {
    const newValue = !thursday;
    setThursday(newValue);

    if (newValue) {
      valueSetter(prev => ({
        ...prev,
        start_thursday: start_time_thursday,
        end_thursday: end_time_thursday
      }));
    } else {
      valueSetter(prev => ({
        ...prev,
        start_thursday: "",
        end_thursday: ""
      }));
    }
  };
  const handleSetFriday = () => {
    const newValue = !friday;
    setFriday(newValue);

    if (newValue) {
      valueSetter(prev => ({
        ...prev,
        start_friday: start_time_friday,
        end_friday: end_time_friday
      }));
    } else {
      valueSetter(prev => ({
        ...prev,
        start_friday: "",
        end_friday: ""
      }));
    }
  };
  const handleSetSaturday = () => {
    const newValue = !saturday;
    setSaturday(newValue);

    if (newValue) {
      valueSetter(prev => ({
        ...prev,
        start_saturday: start_time_saturday,
        end_saturday: end_time_saturday
      }));
    } else {
      valueSetter(prev => ({
        ...prev,
        start_saturday: "",
        end_saturday: ""
      }));
    }
  };
  const handleSetHoliday = () => {
    const newValue = !holiday;
    setHoliday(newValue);

    if (newValue) {
      valueSetter(prev => ({
        ...prev,
        start_holiday: start_time_holiday,
        end_holiday: end_time_holiday
      }));
    }else {
    valueSetter(prev => ({
      ...prev,
      start_holiday: "",
      end_holiday: ""
    }));
  }
    
  };


  const customButtonStyles = ({
    functions: { pxToRem, rgba },
    borders: { borderWidth },
    palette: { transparent, info },
    typography: { size },
  }) => ({
    width: "100%",
    maxWidth: pxToRem(164),
    height: pxToRem(130),
    borderWidth: borderWidth[2],
    mb: 1,
    ml: 0,

    "&.MuiButton-contained, &.MuiButton-contained:hover": {
      boxShadow: "none",
      border: `${borderWidth[2]} solid ${transparent.main}`,
    },

    "&:hover": {
      backgroundColor: `#1A73E8 !important`,
      border: `${borderWidth[2]} solid ${info.main} !important`,
      color: '#fff',
    },
    "& .material-icons-round": {
      fontSize: `${size["3xl"]} !important`,
    },
  });

  return (
    <MDBox>

      <MDBox pt={0}>
        <Grid container spacing={3}>
          <Grid item xl={12} sx={{ height: "max-content" }}>
            <MDBox mt={2}>
              <Grid container spacing={1} >
                <Grid item xs={12} md={5} mb={3}>
                  <Autocomplete
                    options={amenities}
                    value={sourceAmenity}
                    onChange={handleSourceAmenityChange}
                    getOptionLabel={(option) => option?.name || option?.amenity_name || ""}
                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                    renderInput={(params) => (
                      <MDInput
                        {...params}
                        label="Load schedule from another amenity"
                        placeholder="Select amenity"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={4} mb={3} display="flex" alignItems="center">
                  <MDTypography variant="caption" color="text">
                    Select an amenity to copy its weekday and holiday times.
                  </MDTypography>
                </Grid>
                <Grid item xs={12} md={3} mb={3} display="flex" justifyContent="flex-end" alignItems="center">
                  <MDButton color="info" variant="outlined" onClick={handleApplyMondayToAllDays}>
                    Apply Monday To All
                  </MDButton>
                </Grid>
                <Grid container xs={12} md={6} lg={4} item>
                  <Grid item sm={6}>
                    <MDBox textAlign="center">
                      <MDButton
                        color="info"
                        variant={monday ? "contained" : "outlined"}
                        onClick={handleSetMonday}
                        sx={customButtonStyles}
                      >
                        Monday
                      </MDButton>
                    </MDBox>
                  </Grid>
                  <Grid item sm={6} >
                    <Grid item sm={12} mt={2}>
                      <FormField label={"Start"} type={"time"} value={start_time_monday}
                        onChange={(e) => {
                          setStart_time_monday(e.target.value);
                          changeValue("start", "monday", e.target.value);
                        }} />
                    </Grid>
                    <Grid item sm={12} mt={2}>
                      <FormField label={"End"} type={"time"} value={end_time_monday}
                        onChange={(e) => {
                          setEnd_time_monday(e.target.value);
                          changeValue("end", "monday", e.target.value);
                        }} />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={6} lg={4} item>
                  <Grid item sm={6}>
                    <MDBox textAlign="center">
                      <MDButton
                        color="info"
                        variant={tuesday ? "contained" : "outlined"}
                        onClick={handleSetTuesday}
                        sx={customButtonStyles}
                      >
                        Tuesday
                      </MDButton>
                    </MDBox>
                  </Grid>
                  <Grid item sm={6} >
                    <Grid item sm={12} mt={2}>
                      <FormField label={"Start"} type={"time"} value={start_time_tuesday} onChange={(e) => {
                        setStart_time_tuesday(e.target.value);
                        changeValue("start", "tuesday", e.target.value);
                      }} />
                    </Grid>
                    <Grid item sm={12} mt={2}>
                      <FormField label={"End"} type={"time"} value={end_time_tuesday} onChange={(e) => {
                        setEnd_time_tuesday(e.target.value);
                        changeValue("end", "tuesday", e.target.value);
                      }} />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={6} lg={4} item>
                  <Grid item sm={6}>
                    <MDBox textAlign="center">
                      <MDButton
                        color="info"
                        variant={wednesday ? "contained" : "outlined"}
                        onClick={handleSetWednesday}
                        sx={customButtonStyles}
                      >
                        Wednesday
                      </MDButton>
                    </MDBox>
                  </Grid>
                  <Grid item sm={6} >
                    <Grid item sm={12} mt={2}>
                      <FormField label={"Start"} type={"time"} value={start_time_wednesday} onChange={(e) => {
                        setStart_time_wednesday(e.target.value);
                        changeValue("start", "wednesday", e.target.value);
                      }} />
                    </Grid>
                    <Grid item sm={12} mt={2}>
                      <FormField label={"End"} type={"time"} value={end_time_wednesday} onChange={(e) => {
                        setEnd_time_wednesday(e.target.value);
                        changeValue("end", "wednesday", e.target.value);
                      }} />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={6} lg={4} item>
                  <Grid item sm={6}>
                    <MDBox textAlign="center">
                      <MDButton
                        color="info"
                        variant={thursday ? "contained" : "outlined"}
                        onClick={handleSetThursday}
                        sx={customButtonStyles}
                      >
                        Thursday
                      </MDButton>
                    </MDBox>
                  </Grid>
                  <Grid item sm={6} >
                    <Grid item sm={12} mt={2}>
                      <FormField label={"Start"} type={"time"} value={start_time_thursday} onChange={(e) => {
                        setStart_time_thursday(e.target.value);
                        changeValue("start", "thursday", e.target.value);
                      }} />
                    </Grid>
                    <Grid item sm={12} mt={2}>
                      <FormField label={"End"} type={"time"} value={end_time_thursday} onChange={(e) => {
                        setEnd_time_thursday(e.target.value);
                        changeValue("end", "thursday", e.target.value);
                      }} />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={6} lg={4} item>
                  <Grid item sm={6}>
                    <MDBox textAlign="center">
                      <MDButton
                        color="info"
                        variant={friday ? "contained" : "outlined"}
                        onClick={handleSetFriday}
                        sx={customButtonStyles}
                      >
                        Friday
                      </MDButton>
                    </MDBox>
                  </Grid>
                  <Grid item sm={6} >
                    <Grid item sm={12} mt={2}>
                      <FormField label={"Start"} type={"time"} value={start_time_friday} onChange={(e) => {
                        setStart_time_friday(e.target.value);
                        changeValue("start", "friday", e.target.value);
                      }} />
                    </Grid>
                    <Grid item sm={12} mt={2}>
                      <FormField label={"End"} type={"time"} value={end_time_friday} onChange={(e) => {
                        setEnd_time_friday(e.target.value);
                        changeValue("end", "friday", e.target.value);
                      }} />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={6} lg={4} item>
                  <Grid item sm={6}>
                    <MDBox textAlign="center">
                      <MDButton
                        color="warning"
                        variant={saturday ? "contained" : "outlined"}
                        onClick={handleSetSaturday}
                        sx={customButtonStyles}
                      >
                        Saturday
                      </MDButton>
                    </MDBox>
                  </Grid>
                  <Grid item sm={6} >
                    <Grid item sm={12} mt={2}>
                      <FormField label={"Start"} type={"time"} value={start_time_saturday} onChange={(e) => {
                        setStart_time_saturday(e.target.value);
                        changeValue("start", "saturday", e.target.value);
                      }} />
                    </Grid>
                    <Grid item sm={12} mt={2}>
                      <FormField label={"End"} type={"time"} value={end_time_saturday} onChange={(e) => {
                        setEnd_time_saturday(e.target.value);
                        changeValue("end", "saturday", e.target.value);
                      }} />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={6} lg={4} item>
                  <Grid item sm={6}>
                    <MDBox textAlign="center">
                      <MDButton
                        color="warning"
                        variant={sunday ? "contained" : "outlined"}
                        onClick={handleSetSunday}
                        sx={customButtonStyles}
                      >
                        Sunday
                      </MDButton>
                    </MDBox>
                  </Grid>
                  <Grid item sm={6} >
                    <Grid item sm={12} mt={2}>
                      <FormField label={"Start"} type={"time"} value={start_time_sunday} onChange={(e) => {
                        setStart_time_sunday(e.target.value);
                        changeValue("start", "sunday", e.target.value);
                      }} />
                    </Grid>
                    <Grid item sm={12} mt={2}>
                      <FormField label={"End"} type={"time"} value={end_time_sunday} onChange={(e) => {
                        setEnd_time_sunday(e.target.value);
                        changeValue("end", "sunday", e.target.value);
                      }} />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container xs={12} md={6} lg={4} item>
                  <Grid item sm={6}>
                    <MDBox textAlign="center">
                      <MDButton
                        color="secondary"
                        variant={holiday ? "contained" : "outlined"}
                        onClick={handleSetHoliday}
                        sx={customButtonStyles}
                      >
                        Holiday
                      </MDButton>
                    </MDBox>
                  </Grid>
                  <Grid item sm={6} >
                    <Grid item sm={12} mt={2}>
                      <FormField label={"Start"} type={"time"} value={start_time_holiday} onChange={(e) => {
                        setStart_time_holiday(e.target.value);
                        changeValue("start", "holiday", e.target.value);
                      }} />
                    </Grid>
                    <Grid item sm={12} mt={2}>
                      <FormField label={"End"} type={"time"} value={end_time_holiday} onChange={(e) => {
                        setEnd_time_holiday(e.target.value);
                        changeValue("end", "holiday", e.target.value);
                      }} />
                    </Grid>
                  </Grid>
                </Grid>

              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default AmenityTimingWeekDay;
